import { ComponentStyleConfig } from '@chakra-ui/react'

export default <ComponentStyleConfig>{
  baseStyle: {
    field: {
      _focus: {
        boxShadow: 'none',
      },
      _hover: { boxShadow: 'none' },
    },
  },
}
